import { useState } from 'react';
import config from '../config';
import Footer from '../components/Footer';

// ── CONTACT INFO BLOCKS ────────────────────────────────────────
const INFO = [
  {
    label: 'Telefon',
    value: <a href={config.phoneHref}>{config.phone}</a>,
    sub:   'Jourlinje – svarar dygnet runt',
    icon: (
      <svg className="ci-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.64a16 16 0 0 0 6 6l1-1a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
  },
  {
    label: 'E-post',
    value: <a href={`mailto:${config.email}`}>{config.email}</a>,
    sub:   'Svar inom 24 timmar',
    icon: (
      <svg className="ci-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
  },
  {
    label: 'Område',
    value: config.area,
    sub:   'Vi kör ut till hela regionen',
    icon: (
      <svg className="ci-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
  },
  {
    label: 'Svarstid',
    value: 'Inom 4 timmar',
    sub:   'Mål vid akuta ärenden',
    icon: (
      <svg className="ci-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
  },
];

// ══════════════════════════════════════════════════════════════
export default function Contact({ navigate }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = () => {
    const emailEl = document.getElementById('f-email');
    const phoneEl = document.getElementById('f-phone');
    const newErrors = {};
    if (!emailEl?.value.trim()) newErrors.email = true;
    if (!phoneEl?.value.trim()) newErrors.phone = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    setSubmitted(true);
  };

  const fieldStyle = (hasError) => ({
    borderColor: hasError ? '#e05252' : undefined,
    boxShadow:   hasError ? '0 0 0 3px rgba(224,82,82,.15)' : undefined,
  });

  return (
    <>
      {/* ── HERO ── */}
      <div className="contact-page-hero">
        <div className="sl">Kontakt</div>
        <div className="st">KONTAKTA OSS</div>
        <p>Fyll i formuläret så återkommer vi inom 24 timmar. Akut ärende? Ring oss direkt på jouret.</p>
      </div>

      {/* ── SPLIT LAYOUT ── */}
      <div className="contact-layout">

        {/* Left: contact info */}
        <div className="contact-info-col">
          {INFO.map(({ label, value, sub, icon }) => (
            <div key={label}>
              {icon}
              <div className="ci-label">{label}</div>
              <div className="ci-val">{value}</div>
              <div className="ci-sub">{sub}</div>
            </div>
          ))}
        </div>

        {/* Right: form */}
        <div className="contact-form-col">
          <div className="form-title">SKICKA ETT MEDDELANDE</div>
          <div className="form-sub">Fyll i formuläret nedan så hör vi av oss snarast. Fält markerade med * är obligatoriska.</div>

          {!submitted ? (
            <>
              <div className="field-row">
                <div className="field">
                  <label>E-postadress <span className="req" style={{ color:'var(--accent)' }}>*</span></label>
                  <input id="f-email" type="email" placeholder="din@email.se" style={fieldStyle(errors.email)} onChange={() => setErrors(e => ({...e, email: false}))} />
                </div>
                <div className="field">
                  <label>Telefonnummer <span className="req" style={{ color:'var(--accent)' }}>*</span></label>
                  <input id="f-phone" type="tel" placeholder="070-000 00 00" style={fieldStyle(errors.phone)} onChange={() => setErrors(e => ({...e, phone: false}))} />
                </div>
              </div>
              <div className="field-row full">
                <div className="field">
                  <label>Företagsnamn</label>
                  <input id="f-company" type="text" placeholder="Ditt företag (valfritt)" />
                </div>
              </div>
              <div className="field-row full">
                <div className="field">
                  <label>Meddelande</label>
                  <textarea id="f-message" placeholder="Beskriv ditt ärende..." />
                </div>
              </div>
              <div className="form-submit">
                <p className="form-note">
                  Vi delar aldrig dina uppgifter med tredje part.<br />
                  Akut? Ring oss direkt på{' '}
                  <a href={config.phoneHref} style={{ color:'var(--accent)' }}>{config.phone}</a>.
                </p>
                <button className="bp" onClick={handleSubmit}>Skicka meddelande</button>
              </div>
            </>
          ) : (
            <div className="form-success show">
              <svg className="form-success-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
              <h3>TACK FÖR DITT MEDDELANDE!</h3>
              <p>
                Vi återkommer till dig inom 24 timmar. Akut ärende? Ring oss direkt på{' '}
                <a href={config.phoneHref} style={{ color:'var(--accent)' }}>{config.phone}</a>.
              </p>
            </div>
          )}
        </div>
      </div>

      <Footer navigate={navigate} />
    </>
  );
}
